var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-8 bg-gray-100 text-center max-w-4xl"},[_vm._v(" 재무팀 또는 해당 사건 관련인만 접근 가능합니다. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }